import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <TopicsSection />
        <FaqSection />
        <IndexSection />
        <ContactSection />
        <CarouselSection />
        <FeaturesSection />
        <CardsSection />
        <AboutSection />
        <CommentsSection />
        <AppSection />
        <RankingSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}